var $selectType = $('.js-select-type');
var $formWrap = $('.js-form-wrap');
var $applySuccess = $('.js-apply-success');
var $form = $('.js-form');
var applying = false;
var applyTypeMap = { // 1=单人报名；2=结契报名；3=619生日报名
    single: 1,
    jieqi: 2,
    birthday: 3
};
var applyType = '';
var status = '';

var applyObj = {
    applyed: !!response.applyed,
};

if (applyObj.applyed) {
    status = 'success';
    render();
}

// 报名表单提交
$form.on('submit', function (e) {
    e.preventDefault();

    if (applying) {
        return;
    }

    var data = validData($form);

    if (data.error) {
        return;
    }

    applying = true;

    $.ajax({
        url: '/anniversary/apply.json',
        data: data,
        method: 'POST'
    })
    .success(function (res) {
        if (res.resCode === 0) {
            status = 'success';
            render();
            applyObj.applyed = true;
        } else {
            alert('报名失败，错误码：' + res.resCode);
        }
        applying = false;
    })
    .fail(function () {
        applying = false;
    });
});

// 选择报名类型
$selectType.on('click', 'a', function () {
    var type = $(this).data('type');

    status = 'apply';
    render();
    $formWrap.find('[data-type]').hide().filter('[data-type=' + type + ']').show();
    applyType = applyTypeMap[type];
});

function render () {
    switch (status) {
        case 'select':
            $selectType.show();
            $formWrap.hide();
            $applySuccess.hide();
            break;
        case 'apply':
            $selectType.hide();
            $formWrap.show();
            $applySuccess.hide();
            break;
        case 'success':
            $selectType.hide();
            $formWrap.hide();
            $applySuccess.show();
            break;
    }
}

function showError (name, data) {
    $form.find('[name="' + name + '"]').closest('div').addClass('error');
    data && (data.error = true);
}

function resetForm () {
    $form.find('input, select').closest('div').removeClass('error');
    $form.find('input:not([type=radio]), select').val('');
}

$form.on('focus click', 'input, select', function () {
    $(this).closest('div').removeClass('error');
});

// 验证数据，在没有错误情况下，返回数据
function validData () {
    var data = {};

    $form.find('input, select').closest('div').removeClass('error');
    $form.find('.js-form-group:visible').find('input[name], select[name]').each(function (i, input) {
        var value = '';
        
        switch (input.type) {
            case 'radio':
                var $radios = $form.find('input[name=' + input.name + ']');
                data[input.name] = $radios.filter(':checked').val();
                break;
            default:
                data[input.name] = $.trim(input.value);
                break;
        }

        value = data[input.name];

        switch (input.name) {
            case 'realName':
                if (!value || !value.match(/^[\u4e00-\u9fa5]{1,4}$/)) { showError(input.name, data); }
                break;
            case 'phone':
                if (!value || !value.match(/^\d{11}$/)) { showError(input.name, data); }
                break;
            case 'gender':
                if (!value) { showError(input.name, data); }
                break;
            case 'roleInfo':
                if (!value) { showError(input.name, data); }
                break;
            case 'city':
                if (!value) { showError(input.name, data); }
                break;
            case 'jieqiRoleName':
                if (!value) { showError(input.name, data); }
                break;
        }
    });

    data.applyType = applyType;

    return data;
}

applyObj.reset = function () {
    status = 'select';
    render();
    resetForm();
};

// 重置form
module.exports = applyObj;



//////////////////
// WEBPACK FOOTER
// ./pages/anniversary/js/form.js
// module id = 4
// module chunks = 2 3